import {
  EcosystemFeaturedDetailInfo,
  EcosystemFeaturedSummaryInfo, EcosystemProjectDescriptionInfo,
  OpenGraphInfo
} from '~/api/repository'
import { EcosystemProjectSummaryModel } from '~/types/model/ecosystem/project-detail.model'
import { convertDateToAge } from '~/utils/date'

export class EcosystemFeaturedSummaryModel {
  private _featuredId: string
  private _title: string
  private _thumbnail: string

  constructor(data: EcosystemFeaturedSummaryInfo) {
    this._featuredId = data.FRDID
    this._title = data.TI
    this._thumbnail = data.TBPC
  }

  get featuredId(): string {
    return this._featuredId
  }

  get title(): string {
    return this._title
  }

  get thumbnail(): string {
    return this._thumbnail
  }
}

class OpenGraphModel {
  private _title: string
  private _description: string
  private _image: string

  constructor(title: string, description: string, image: string) {
    this._title = title
    this._description = description
    this._image = image
  }

  get title(): string {
    return this._title
  }

  get description(): string {
    return this._description
  }

  get image(): string {
    return this._image
  }
}

export class EcosystemFeaturedDetailModel {
  private _projectInfo: EcosystemProjectDescriptionInfo
  private _title: string
  private _thumbnail: string
  private _desktopContentImage: string
  private _mobileContentImage: string
  private _content: string
  private _openGraphInfo: OpenGraphInfo
  private _featuredId: string
  private _createdAt: string

  constructor(data: EcosystemFeaturedDetailInfo) {
    this._projectInfo = data.ABT
    this._title = data.TI
    this._thumbnail = data.TBPC
    this._desktopContentImage = data.CTNTIMGPC
    this._mobileContentImage = data.CTNTIMGMB
    this._content = data.BD
    this._openGraphInfo = data.OPNGRPH
    this._featuredId = data.FRDID
    this._createdAt = data.CRTDAT
  }

  get projectInfo(): EcosystemProjectSummaryModel {
    return new EcosystemProjectSummaryModel({
      projectId: this._projectInfo.ID,
      name: this._projectInfo.NM,
      categoryList: this._projectInfo.CATGLIST,
      logoUrl: this._projectInfo.LGURL,
      description: this._projectInfo.ONEDESC
    })
  }

  get title(): string {
    return this._title
  }

  get thumbnail(): string {
    return this._thumbnail
  }

  get desktopContentImage(): string {
    return this._desktopContentImage
  }

  get mobileContentImage(): string {
    return this._mobileContentImage
  }

  get content(): string {
    return this._content
  }

  get openGraphInfo(): OpenGraphModel {
    return new OpenGraphModel(this._openGraphInfo.TI, this._openGraphInfo.DESC, this._thumbnail)
  }

  get featuredId(): string {
    return this._featuredId
  }

  get createdAt(): string {
    return convertDateToAge(new Date(parseInt(this._createdAt) * 1000))
  }
}